module.exports = __webpack_public_path__ + "static/central-america-map-8190e0468a6bb66ebb84845ab466a360.svg";